module.exports = __webpack_public_path__ + "static/ArchiveVideo04-b919cf57e9edb9b80ae90aaf415a2a9a.mp4";